import { createI18n } from 'vue-i18n';

const messages = {
  en: {
    internal_server_error: 'Internal server error',
    route_not_found: 'The requested route does not exist.',
    validation_error: 'Invalid input provided',
    login: {
      title: 'Login',
      email: 'Email',
      password: 'Password',
      button: 'Login',
      loading: 'Logging in...',
      error: 'An error occurred, please try again.',
      id: 'ID',
      username: 'Username',
    },
    auth: {
      register_success: 'User registered successfully',
      login_success: 'Successfully logged in',
      login_failed: 'Login failed',
      invalid_credentials: 'Invalid login credentials',
      too_many_attempts: 'Too many failed attempts, try again later',
      account_locked: 'Account temporarily locked',
      failed_login: 'Invalid input provided',
      token_creation_failed: 'Token generation failed',
      token_refreshed: 'Token refreshed successfully',
      token_expired: 'Token expired, please log in again',
      token_refresh_failed: 'Failed to refresh token',
      logout_success: 'Successfully logged out',
      logout_failed: 'An error occurred during logout',
      token_or_username_missing: 'Token or username not provided',
    },
    errors: {
      http_error: 'HTTP error',
      validation_error: 'Invalid input provided',
      unauthorized_access: 'Authorization required',
      resource_not_found: 'Resource not found',
      internal_server_error: 'Internal server error',
      too_many_requests: 'Too many requests, please try again later',
      forbidden: 'Access to this resource is forbidden',
      bad_request: 'Bad request',
      method_not_allowed: 'Method not allowed',
      request_timeout: 'Request timed out',
      conflict: 'Data conflict',
      gone: 'Resource is gone',
      length_required: 'Length required',
      payload_too_large: 'Payload too large',
      unsupported_media_type: 'Unsupported media type',
      not_implemented: 'Feature not implemented',
      bad_gateway: 'Bad gateway',
      service_unavailable: 'Service temporarily unavailable',
      gateway_timeout: 'Gateway timeout',
      failed_to_fetch_data: 'Failed to fetch data',
      route_not_found: 'The requested route does not exist.',
      invalid_current_password: 'Invalid currnet password',
      user_not_found: 'User not found',
      not_found: 'Resource not found',
      message_not_found: 'Message not found',
      photo_not_found: 'Photo not found',
      failed_to_delete_template: 'Failed to delete template',
      device_forbidden: 'Selected device is not accessible for this user',
      invalid_from_date: 'Invalid "from" date',
      invalid_to_date: 'Invalid "to" date',
      invalid_date_range: 'Invalid date range',
      invalid_granularity: 'Invalid granularity value',
      invalid_metric: 'Invalid metric value',
    },
    sidebar: {
      dashboard: "Dashboard",
      users: "Users",
      settings: "Settings",
      profile: "Profile",
      logout: "Logout",
      devices: "Devices",
      device_list: "Devices List",
      closed_days: "Closed Days",
      cleared_days: "Cleared Days",
      inserted_coins: "Inserted Coins",
      device_messages: "Messages",
      templates: "Templates",
      price: "Pricing",
      photos: "Photos",
      reports: "Reports",
      photo_stats: "Photo Stats",
      revenue_analytics: "Business Analytics",
    },
    validation: {
      email_required: 'Please enter a valid email address',
      password_required: 'Please enter your password',
      required: 'This field is required',
      email_invalid: 'Please enter a valid email address',
      too_short: 'Input is too short',
      too_long: 'Input is too long',
      pattern_mismatch: 'Input does not match the required format',
      number_invalid: 'Please enter a number',
      min_value: 'Minimum allowed value is {min}',
      max_value: 'Maximum allowed value is {max}',
      step_mismatch: 'Number does not match the allowed step',
      date_invalid: 'Please enter a valid date',
      time_invalid: 'Please enter a valid time',
      month_invalid: 'Please enter a valid month',
      url_invalid: 'Please enter a valid URL',
      file_invalid: 'Please select a file',
      select_invalid: 'Please select a valid option',
      checkbox_required: 'Please check this box',
    },
    user: {
      name: 'Name',
      role: 'Role',
    },
    table: {
      created_at: 'Created At',
      updated_at: 'Updated At',
    }
  },
};

const i18n = createI18n({
  allowComposition: true,
  missingWarn: false,
  fallbackWarn: false,
  legacy: false,
  locale: 'en',
  fallbackLocale: 'en',
  messages,
  globalInjection: true,
});

export default i18n;
